import React from "react";
import { Box } from "@mui/material";
import routes from "../../../constants/routes";

// How a request to participate is named and coloured on every screen

const STYLES = {
  WAITING: { label: "Waiting", color: "#1C3BB0", background: "#E8EDFD" },
  APPROVED: { label: "Approved", color: "#14532D", background: "#DDF3E6" },
  NOT_ACCEPTED: { label: "Not accepted", color: "#8A2412", background: "#FBE3DE" },
  CLOSED: { label: "Closed", color: "#374151", background: "#EEF0F3" },
  WITHDRAWN: { label: "Withdrawn", color: "#374151", background: "#EEF0F3" },
  ADDED: { label: "Added by organiser", color: "#14532D", background: "#DDF3E6" },
  REMOVED: { label: "Removed", color: "#374151", background: "#EEF0F3" },
};

// the Edit auction screen opened at its Requests tab
export const requestsTabPath = (eventId) =>
  `${routes.dashboardAuction}?view=EditTabEvent&eventId=${eventId}&tab=requests`;

// the key of STYLES for a request; `participant` (true / false / undefined
// when not known) tells "added" and "removed" apart where the screen knows it
export const joinRequestState = (request, participant) => {
  if (!request) return null;
  if (request.status === "CLOSED" && request.closedReason === "ADDED_BY_ORGANISER") {
    return participant === false ? "REMOVED" : "ADDED";
  }
  if (request.status === "APPROVED" && participant === false) return "REMOVED";
  // a rejected request followed by Add bidder: he is in now
  if (request.status === "REJECTED" && participant === true) return "ADDED";
  return {
    PENDING: "WAITING",
    APPROVED: "APPROVED",
    REJECTED: "NOT_ACCEPTED",
    WITHDRAWN: "WITHDRAWN",
    CLOSED: "CLOSED",
  }[request.status];
};

// the extra words after the status, e.g. "Auction ended"
export const joinRequestDetail = (request) => {
  if (!request) return "";
  if (request.status === "CLOSED" && request.closedReason === "AUCTION_ENDED") {
    return "Auction ended";
  }
  if (request.status === "REJECTED" && request.rejectionReason) {
    return `"${request.rejectionReason}"`;
  }
  return "";
};

export const JoinRequestChip = ({ state, label }) => {
  const style = STYLES[state];
  if (!style) return null;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        px: 1,
        py: 0.25,
        fontSize: 12,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: 0.3,
        color: style.color,
        backgroundColor: style.background,
        whiteSpace: "nowrap",
      }}
    >
      {label || style.label}
    </Box>
  );
};

export default JoinRequestChip;
